export default "__VITE_ASSET__v4CYl__X__"